import axios from 'axios';
import { API_VIRSION } from 'config';
// Users api
export const getPost = (id) => axios.get(`${API_VIRSION}/admin/post/${id}`);

export const deletePost = (id) => axios.delete(`${API_VIRSION}/admin/post/${id}`);
